module.exports = __webpack_public_path__ + "static/media/backDrop.0a808117.png";